import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import {
  getSetupAreaVersionStatusLabel,
  SetupArea,
  SetupAreaVersionStatus
} from 'nekst-api';
import { TextBadge, TextBadgeStyle } from 'features/tasks-forms';

function MarketVisibilityIconWidget(props: {
  setupArea: SetupArea
}) {
  let badgeStyle = TextBadgeStyle.ACTIVE;

  const version = props.setupArea.versions[0];

  if (version) {
    switch (version.status) {
      case SetupAreaVersionStatus.PUBLISHED:
        badgeStyle = TextBadgeStyle.ACTIVE;
        break;
      case SetupAreaVersionStatus.ARCHIVED:
        badgeStyle = TextBadgeStyle.INACTIVE;
        break;
      case SetupAreaVersionStatus.DRAFT:
        badgeStyle = TextBadgeStyle.DRAFT;
        break;
    }

    return (
      <TextBadge text={getSetupAreaVersionStatusLabel(version.status)} style={badgeStyle}  />
    );
  } else {
    return null;
  }

}

export function MarketVisibilityIcon() {
  const { data: setupArea } = useShowContextRequired<SetupArea>();

  return (
    <MarketVisibilityIconWidget setupArea={setupArea} />
  );
}
